/**
 * Provider del contexto de métricas (F2). Suscribe el `subscribe` inyectado y
 * publica las métricas al árbol. La lógica (contexto, hook, watchers en vivo)
 * vive en `metricsContext.ts`.
 */
import { useEffect, useState, type ReactNode } from 'react';
import { MetricsContext, type MetricsSubscribe } from './metricsContext';
import type { AdminMetrics } from './metrics';

export function MetricsProvider({
  subscribe,
  children,
}: {
  subscribe?: MetricsSubscribe;
  children: ReactNode;
}): ReactNode {
  const [metrics, setMetrics] = useState<AdminMetrics | null>(null);

  useEffect(() => {
    if (!subscribe) return;
    return subscribe(setMetrics);
  }, [subscribe]);

  return <MetricsContext.Provider value={metrics}>{children}</MetricsContext.Provider>;
}
